'use client';

import React, { createContext, useContext, useState } from 'react';

interface MonthContextValue {
  selectedMonth: string;
  setSelectedMonth: (month: string) => void;
  /** Returns { year, monthIndex } (0-based month index) for the selected month */
  selectedMonthDate: { year: number; monthIndex: number };
}

const now = new Date();
const defaultMonths = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
const defaultMonth = `${defaultMonths[now.getMonth()]} ${now.getFullYear()}`;

const MonthContext = createContext<MonthContextValue>({
  selectedMonth: defaultMonth,
  setSelectedMonth: () => {},
  selectedMonthDate: { year: now.getFullYear(), monthIndex: now.getMonth() },
});

export function MonthProvider({ children }: { children: React.ReactNode }) {
  const [selectedMonth, setSelectedMonth] = useState(defaultMonth);

  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  const parts = selectedMonth.split(' ');
  const monthIndex = months.indexOf(parts[0]);
  const year = parseInt(parts[1], 10);

  return (
    <MonthContext.Provider
      value={{
        selectedMonth,
        setSelectedMonth,
        selectedMonthDate: { year: isNaN(year) ? now.getFullYear() : year, monthIndex: monthIndex >= 0 ? monthIndex : now.getMonth() },
      }}
    >
      {children}
    </MonthContext.Provider>
  );
}

export function useMonth() {
  return useContext(MonthContext);
}
